export default __webpack_public_path__ + "static/media/m_wdt_c_5.1f8b068e.mp3";